import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80737a34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-selector-with-modal" }
const _hoisted_2 = { class: "selector-container" }
const _hoisted_3 = { class: "selector-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-briefcase-fill" })
], -1))
const _hoisted_5 = { class: "header-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "selector-title" }, "Select Application", -1))
const _hoisted_7 = { class: "selector-description" }

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import ApplicationSelector from "@/components/ApplicationSelector.vue";
import CreateApplication from "@/views/CreateApplication.vue";
import { ApplicationApiService } from "@/services/ApplicationApiService";

interface Application {
  _id: string;
  roleTitle: string;
  companyName: string;
  applicationId: string;
  [key: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationSelectorWithModal',
  props: {
  redirectType: {
    type: String,
    default: "",
  },
  resumeId: {
    type: String,
    default: "",
  },
  redirectRoute: {
    type: String,
    default: "",
  },
  selectorDescription: {
    type: String,
    default: "Select an application",
  },
},
  emits: ["application-selected", "application-created"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();
const loading = ref(false);
const applications = ref<Application[]>([]);
const showCreateApplicationModal = ref(false);

// Fetch applications on component mount
onMounted(() => {
  fetchApplicationsList();
});

// Fetch the list of applications
const fetchApplicationsList = async () => {
  loading.value = true;
  try {
    const response = await ApplicationApiService.getUserApplicationList();
    if (response.status === 200 && response.data) {
      // Map the response data to include applicationId if it doesn't exist
      applications.value = response.data.applications.map((app: any) => ({
        ...app,
        applicationId: app.applicationId || app._id,
      }));
    }
  } catch (error) {
    console.error("Error fetching applications:", error);
  } finally {
    loading.value = false;
  }
};

// Select an application
const selectApplication = (app: Application) => {
  emit("application-selected", app.applicationId);

  // If redirectRoute is provided, redirect the user
  if (props.redirectRoute) {
    handleRedirect(app.applicationId);
  }
};

// Handle the application creation completion
const onApplicationCreated = (application: any) => {
  showCreateApplicationModal.value = false;
  const applicationId = application?.id || application;
  emit("application-created", applicationId);

  // If redirectRoute is provided, redirect the user
  if (props.redirectRoute) {
    handleRedirect(applicationId);
  }
};

// Handle redirection based on the redirectRoute prop
const handleRedirect = (applicationId: string) => {
  if (!applicationId) return;

  // Different redirect logic based on the redirectType
  if (props.redirectType === "resume" && props.resumeId) {
    router.push({
      name: props.redirectRoute,
      params: {
        applicationId: applicationId,
        resumeId: props.resumeId,
      },
    });
  } else if (props.redirectType === "coverLetter") {
    router.push({
      name: props.redirectRoute,
      query: { applicationId },
    });
  } else if (props.redirectType === "interviewPractice") {
    // Navigate to interview practice for the selected application
    router.push(`/application/${applicationId}/interview-practice`);
  } else {
    // Default redirect
    router.push({
      name: props.redirectRoute,
      query: { applicationId },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.selectorDescription), 1)
        ])
      ]),
      _createVNode(ApplicationSelector, {
        loading: loading.value,
        applications: applications.value,
        onSelectApplication: selectApplication,
        onCreateApplication: _cache[0] || (_cache[0] = ($event: any) => (showCreateApplicationModal.value = true))
      }, null, 8, ["loading", "applications"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showCreateApplicationModal.value)
        ? (_openBlock(), _createBlock(CreateApplication, {
            key: 0,
            show: showCreateApplicationModal.value,
            "is-modal": true,
            "resume-id": __props.resumeId,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (showCreateApplicationModal.value = false)),
            onApplicationCreated: onApplicationCreated
          }, null, 8, ["show", "resume-id"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})